import { useRef, useState, useEffect, useCallback } from 'react';

export function ScrollArea({ children, className = '' }) {
  const ref = useRef(null);
  const [thumb, setThumb] = useState({ need: false, top: 0, height: 0 });
  const hideTimer = useRef(null);
  const [active, setActive] = useState(false);

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    const need = scrollHeight > clientHeight + 1;
    setThumb({
      need,
      top: (scrollTop / scrollHeight) * clientHeight,
      height: Math.max((clientHeight / scrollHeight) * clientHeight, 28),
    });
  }, []);

  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return;
    el.addEventListener('scroll', update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      el.removeEventListener('scroll', update);
      ro.disconnect();
    };
  }, [update]);

  const onScrollStart = () => {
    setActive(true);
    clearTimeout(hideTimer.current);
  };
  const onScrollEnd = () => {
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setActive(false), 900);
  };

  return (
    <div className={`relative flex-1 min-h-0 ${className}`}>
      <div
        ref={ref}
        onScroll={update}
        onTouchStart={onScrollStart}
        onTouchEnd={onScrollEnd}
        onMouseEnter={onScrollStart}
        onMouseLeave={onScrollEnd}
        className="h-full overflow-y-auto space-y-3 pr-3"
        style={{
          scrollbarWidth: 'none',       // Firefox
          msOverflowStyle: 'none',      // IE/Edge legacy
        }}
      >
        {children}
      </div>

      {thumb.need && (
        <div
          aria-hidden
          className="pointer-events-none absolute right-0 top-0 bottom-0 w-[4px]"
        >
          <div
            className="absolute w-full rounded-full transition-opacity duration-300"
            style={{
              top: thumb.top,
              height: thumb.height,
              background: 'var(--accent, #22d3ee)',
              opacity: active ? 1 : 0.45, // ← всегда видно, ярче при скролле
            }}
          />
        </div>
      )}
    </div>
  );
}